var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Container, Divider, LinearProgress, Stack, ThemeProvider, Typography, } from "@mui/material";
import Heading from "./Heading";
import Footer from "./Footer";
import getTheme from "./Theme";
import React, { useEffect, useState } from "react";
import { ContentCardStacks } from "./components/ContentCardStacks";
import { ContentCard } from "./components/ContentCard";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import { restoreSession, useProfileAuthStore, } from "./store/ProfileStore";
import { useNavigate } from "react-router-dom";
import { NewChannelCard } from "./components/NewChannelCard";
import { channelOperation, listChannelsByOwner, loadChannelData, } from "./util/DataUtils";
import { ChannelCard } from "./components/ChannelCard";
import { getChannelViewBaseURL, getContentURL } from "./ContentAPI";
import { loadFriendChannels, useFriendsStore } from "./store/FriendStore";
import { loadFrontPageDiscovery } from "./store/DiscoveryStore";
import { useCacheBusterStore } from "./util/UrlUtils";
import { useLogger } from "./logger";
import { getRecentChannels } from "./store/ChannelStore";
import { TopButtonMenu } from "./components/TopButtonMenu";
const LOGPREFIX = "Channels: ";
export const Channels = () => {
    const [loading, setLoading] = useState();
    const [myChannelsLoading, setMyChannelsLoading] = useState();
    const [myChannelsLoaded, setMyChannelsLoaded] = useState();
    const [myChannelsLoadError, setMyChannelsLoadError] = useState();
    const [myChannelIds, setMyChannelIds] = useState();
    const [friendChannelsLoading, setFriendChannelsLoading] = useState();
    const [friendChannelsLoadError, setFriendChannelsLoadError] = useState();
    const [friendChannelIds, setFriendChannelIds] = useState([]);
    const [memberChannelIds, setMemberChannelIds] = useState([]);
    const [recentChannelIds, setRecentChannelIds] = useState([]);
    const [addNewChannelFormVisible, setAddNewChannelFormVisible] = useState();
    const [discoveryCards, setDiscoveryCards] = useState([]);
    const auth = useProfileAuthStore((state) => state);
    const cacheBusterStore = useCacheBusterStore((state) => state);
    const friendsStore = useFriendsStore();
    const navigate = useNavigate();
    const logger = useLogger((state) => state);
    const loadMemberChannels = () => __awaiter(void 0, void 0, void 0, function* () {
        logger.log(LOGPREFIX + "Channels:loadMemberChannels");
        // Force cache invalidation for member channels
        channelOperation({
            operation: "listChannelsMembership",
        }, {
            okCallback: (clientDetailCode, data) => __awaiter(void 0, void 0, void 0, function* () {
                logger.log(LOGPREFIX +
                    "Channels:loadMemberChannels: " +
                    clientDetailCode +
                    " " +
                    data);
                setLoading(false);
                const results = JSON.parse(data);
                logger.log(LOGPREFIX +
                    "Channels:loadMemberChannels results = " +
                    JSON.stringify(results));
                if (results.channelIds) {
                    const channelIdsToValidate = [];
                    results.channelIds.forEach((channelId) => {
                        if (!memberChannelIds.includes(channelId)) {
                            channelIdsToValidate.push(channelId);
                        }
                    });
                    logger.log(LOGPREFIX +
                        "Validating member channels: " +
                        channelIdsToValidate.length);
                    // Validate each channel
                    const validChannelIds = [];
                    for (const channelPath of channelIdsToValidate) {
                        try {
                            const pathParts = channelPath.split("/");
                            const channelOwnerId = pathParts[1];
                            const channelId = pathParts[2];
                            yield new Promise((resolve) => {
                                const validationCallbacks = {
                                    okCallback: () => {
                                        validChannelIds.push(channelPath);
                                        logger.log(LOGPREFIX + `Member channel ${channelId} is valid`);
                                        resolve();
                                    },
                                    errorCallback: (clientDetailCode, errorMessage) => {
                                        logger.log(LOGPREFIX +
                                            `Member channel ${channelId} is invalid/deleted: ${errorMessage} (${clientDetailCode})`);
                                        resolve();
                                    },
                                };
                                loadChannelData("u", channelOwnerId, channelId, "channelData", "json", validationCallbacks, auth, cacheBusterStore, logger);
                            });
                        }
                        catch (err) {
                            logger.log(LOGPREFIX +
                                `Error checking member channel ${channelPath}: ${err}`);
                        }
                    }
                    setMemberChannelIds(validChannelIds);
                    logger.log(LOGPREFIX +
                        "Valid Member Channel IDs: " +
                        JSON.stringify(validChannelIds));
                }
            }),
            errorCallback: (clientDetailCode, errorMessage) => {
                logger.error(LOGPREFIX +
                    "Channels: loadMemberChannels: ERROR = " +
                    errorMessage +
                    " " +
                    clientDetailCode);
                // TODO
                // setErrorMessage(errorMessage + " (" + clientDetailCode + ")");
            },
        }, {
            isSignedIn: () => auth.isSignedIn(),
            bearer: () => auth.bearer,
            sequence: () => auth.sequence,
            setBearerAndSequence: (bearer, sequence) => {
                auth.setBearerAndSequence(bearer, sequence, logger);
            },
            getAuth: () => {
                return auth;
            },
        }, cacheBusterStore, logger);
    });
    const loadRecentChannels = () => __awaiter(void 0, void 0, void 0, function* () {
        logger.log(LOGPREFIX + "Channels:loadRecentChannels");
        try {
            const recentChannels = getRecentChannels();
            const validChannelIds = [];
            const validRecentChannels = [];
            logger.log(LOGPREFIX + "Validating recent channels: " + recentChannels.length);
            // Validate each recent channel by attempting to load its data
            for (const channel of recentChannels) {
                try {
                    yield new Promise((resolve) => {
                        const callbacks = {
                            okCallback: () => {
                                // Channel exists - add to valid lists
                                const channelPath = `u/${channel.channelOwnerId}/${channel.channelId}/channelData.json`;
                                validChannelIds.push(channelPath);
                                validRecentChannels.push(channel);
                                logger.log(LOGPREFIX + `Recent channel ${channel.title} is valid`);
                                resolve();
                            },
                            errorCallback: (clientDetailCode, errorMessage) => {
                                // Channel doesn't exist or is inaccessible - skip it
                                logger.log(LOGPREFIX +
                                    `Recent channel ${channel.title} is invalid/deleted: ${errorMessage} (${clientDetailCode})`);
                                resolve(); // Don't reject - just skip this channel
                            },
                        };
                        loadChannelData("u", channel.channelOwnerId, channel.channelId, "channelData", "json", callbacks, auth, cacheBusterStore, logger);
                    });
                }
                catch (err) {
                    logger.log(LOGPREFIX +
                        `Error checking recent channel ${channel.title}: ${err}`);
                    // Continue to next channel
                }
            }
            // Update localStorage with only valid channels
            if (validRecentChannels.length !== recentChannels.length) {
                logger.log(LOGPREFIX +
                    `Removed ${recentChannels.length - validRecentChannels.length} invalid recent channels from localStorage`);
                localStorage.setItem("recentChannels", JSON.stringify(validRecentChannels));
            }
            setRecentChannelIds(validChannelIds);
            logger.log(LOGPREFIX +
                "Valid Recent Channel IDs: " +
                JSON.stringify(validChannelIds));
        }
        catch (err) {
            logger.error(LOGPREFIX + "Error loading recent channels: " + err);
        }
    });
    const doLoadFriendChannels = () => {
        // Force cache invalidation for friend channels
        loadFriendChannels(friendsStore, {
            setFriendChannelIds: (channelIds) => {
                setFriendChannelIds(channelIds);
            },
            getFriendChannelIds: () => {
                return friendChannelIds;
            },
            setLoading: (loading) => {
                setFriendChannelsLoading(loading);
            },
            isLoading: () => {
                return friendChannelsLoading ? true : false;
            },
            setErrorMessage: function (message) {
                setFriendChannelsLoadError(message);
            },
            auth: function () {
                return auth;
            },
        }, cacheBusterStore, logger);
    };
    useEffect(() => {
        const retVal = () => { };
        loadFrontPageDiscovery({
            okCallback: (elements) => {
                setDiscoveryCards(elements.slice(0, 8));
            },
            errorCallback: (errorMessage) => {
                logger.error(LOGPREFIX +
                    "Public.useEffect.discovery load failed: " +
                    errorMessage);
            },
        }, true, navigate, cacheBusterStore, logger, auth);
        return retVal;
    }, [setDiscoveryCards]);
    useEffect(() => {
        logger.log(LOGPREFIX + "useEffect: friendsStore");
        if (friendsStore.ok &&
            friendsStore.friends &&
            friendsStore.friends.length > 0) {
            logger.log(LOGPREFIX + "useEffect: friendsStore - loading friend channels...");
            doLoadFriendChannels();
        }
        else {
            logger.log(LOGPREFIX + "useEffect: friendsStore - not loaded");
        }
        return () => { };
    }, [friendsStore]);
    const loadMyChannels = () => __awaiter(void 0, void 0, void 0, function* () {
        logger.log(LOGPREFIX + "loadMyChannels");
        // Force cache invalidation to ensure fresh channel data
        if (!auth.userId) {
            logger.error(LOGPREFIX + "Missing user ID.");
            setMyChannelsLoading(false);
            setMyChannelsLoaded(true);
            return;
        }
        const input = {
            channelOwnerId: auth.userId,
            operation: "listChannelsByOwner",
        };
        const callbacks = {
            okCallback: function (clientDetailCode, data) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const dataObj = JSON.parse(data);
                        if (dataObj === null || dataObj === void 0 ? void 0 : dataObj.channelIds) {
                            const channelIdsToValidate = [];
                            dataObj === null || dataObj === void 0 ? void 0 : dataObj.channelIds.forEach((channelId) => {
                                if (!channelId.includes(auth.userId + "/" + auth.userId)) {
                                    channelIdsToValidate.push(channelId);
                                }
                            });
                            logger.log(LOGPREFIX +
                                "Validating my channels: " +
                                channelIdsToValidate.length);
                            // Validate each channel
                            const validChannelIds = [];
                            for (const channelPath of channelIdsToValidate) {
                                try {
                                    const pathParts = channelPath.split("/");
                                    const channelOwnerId = pathParts[1];
                                    const channelId = pathParts[2];
                                    yield new Promise((resolve) => {
                                        const validationCallbacks = {
                                            okCallback: () => {
                                                validChannelIds.push(channelPath);
                                                logger.log(LOGPREFIX + `My channel ${channelId} is valid`);
                                                resolve();
                                            },
                                            errorCallback: (clientDetailCode, errorMessage) => {
                                                logger.log(LOGPREFIX +
                                                    `My channel ${channelId} is invalid/deleted: ${errorMessage} (${clientDetailCode})`);
                                                resolve();
                                            },
                                        };
                                        loadChannelData("u", channelOwnerId, channelId, "channelData", "json", validationCallbacks, auth, cacheBusterStore, logger);
                                    });
                                }
                                catch (err) {
                                    logger.log(LOGPREFIX +
                                        `Error checking my channel ${channelPath}: ${err}`);
                                }
                            }
                            setMyChannelIds(validChannelIds);
                            logger.log(LOGPREFIX +
                                "Valid My Channel IDs: " +
                                JSON.stringify(validChannelIds));
                        }
                        else {
                            setMyChannelIds([]);
                        }
                    }
                    catch (err) {
                        logger.error(LOGPREFIX + err);
                        setMyChannelsLoadError(err.message);
                    }
                    finally {
                        setMyChannelsLoading(false);
                        setMyChannelsLoaded(true);
                    }
                });
            },
            errorCallback: function (clientDetailCode, errorMessage) {
                const message = errorMessage
                    ? errorMessage + " (" + clientDetailCode + ")"
                    : "Unknown error (" + clientDetailCode + ")";
                setMyChannelsLoadError(message);
                setMyChannelsLoading(false);
                setMyChannelsLoaded(true);
            },
        };
        const authCallback = {
            isSignedIn: function () {
                return auth.isSignedIn();
            },
            bearer: function () {
                return auth.bearer;
            },
            sequence: function () {
                return auth.sequence;
            },
            setBearerAndSequence: function (bearer, sequence) {
                auth.setBearerAndSequence(bearer, sequence, logger);
            },
            getAuth: () => {
                return auth;
            },
        };
        listChannelsByOwner(input, callbacks, authCallback, cacheBusterStore, logger);
    });
    useEffect(() => {
        const retVal = () => { };
        if (!auth.isSignedIn(logger) || !auth.userId) {
            if (!restoreSession(auth, logger)) {
                logger.log(LOGPREFIX + "User NOT logged in - navigating...");
                navigate("/Welcome", { replace: true });
                return retVal;
            }
        }
        else {
            if (!myChannelsLoaded && !myChannelsLoading) {
                setMyChannelsLoading(true);
                loadMyChannels();
                loadMemberChannels();
                loadRecentChannels();
            }
            if (!friendsStore.ok) {
                friendsStore
                    .load(auth.userId, auth, cacheBusterStore, logger)
                    .then(() => {
                    doLoadFriendChannels();
                });
            }
        }
        return retVal;
    }, [auth.isSignedIn()]);
    // Add effect to handle page visibility changes and force refresh
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden && auth.isSignedIn()) {
                logger.log(LOGPREFIX + "Page visible - forcing cache refresh");
                // Force reload of channel data when page becomes visible
                if (myChannelsLoaded) {
                    setMyChannelsLoaded(false);
                    setMyChannelsLoading(false);
                }
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [auth.isSignedIn(), myChannelsLoaded]);
    useEffect(() => {
        if (myChannelsLoadError) {
            setTimeout(() => {
                setMyChannelsLoadError(undefined);
            }, 4000);
        }
        return () => { };
    }, [myChannelsLoadError]);
    //  const cardsList: ReactElement[] = [];
    const addMyChannelButton = (_jsx(Button, Object.assign({ "aria-label": "Create New Channel", variant: "contained", onClick: () => {
            logger.log(LOGPREFIX + "addMyChannelButton");
            setAddNewChannelFormVisible(true);
        }, sx: { margin: "8px" } }, { children: _jsxs(Stack, Object.assign({ sx: { display: "flex", alignItems: "center" } }, { children: [_jsx(AddToQueueIcon, { fontSize: "large" }), _jsx("br", {}), _jsx(Typography, Object.assign({ variant: "body1" }, { children: "Create New Channel" }))] })) }), "add.channel.button"));
    const myChannelButtons = [];
    const memberChannelButtons = [];
    const friendChannelButtons = [];
    const recentChannelButtons = [];
    if (myChannelsLoadError) {
        myChannelButtons.push(_jsx(ContentCard, { keyStr: "content.card.error.mychannelsmessage", title: "ERROR", backgroundColor: "#FFEEEE", textColor: getTheme().palette.black.main, maxWidth: 0.5, childComponent: _jsx(Typography, Object.assign({ variant: "body1" }, { children: myChannelsLoadError })) }, "content.card.error.mychannelsmessage"));
    }
    else {
        myChannelIds === null || myChannelIds === void 0 ? void 0 : myChannelIds.forEach((channelId) => {
            myChannelButtons.push(_jsx(ChannelCard, { keyStr: "channelcard.mychannels." + channelId, enableEditButtons: false, basePath: getContentURL(), channelJson: channelId, maxWidth: 0.22 }, "channelcard.mychannels." + channelId));
        });
        myChannelButtons.push(addMyChannelButton);
        recentChannelIds === null || recentChannelIds === void 0 ? void 0 : recentChannelIds.forEach((channelId) => {
            recentChannelButtons.push(_jsx(ChannelCard, { keyStr: "channelcard.recentchannels." + channelId, enableEditButtons: false, basePath: getContentURL(), channelJson: channelId, maxWidth: 0.22 }, "channelcard.recentchannels." + channelId));
        });
        memberChannelIds === null || memberChannelIds === void 0 ? void 0 : memberChannelIds.forEach((channelId) => {
            memberChannelButtons.push(_jsx(ChannelCard, { keyStr: "channelcard.memberchannels." + channelId, enableEditButtons: false, basePath: getContentURL(), channelJson: channelId, maxWidth: 0.22 }, "channelcard.memberchannels." + channelId));
        });
        if (friendChannelsLoadError) {
            friendChannelButtons.push(_jsx(ContentCard, { keyStr: "content.card.error.friendchannelsmessage", title: "ERROR", backgroundColor: "#FFEEEE", textColor: getTheme().palette.black.main, maxWidth: 0.5, childComponent: _jsx(Typography, Object.assign({ variant: "body1" }, { children: myChannelsLoadError })) }, "content.card.error.friendchannelsmessage"));
        }
        else if (friendChannelsLoading) {
            friendChannelButtons.push(_jsx(LinearProgress, {}, "friendchannels.loading"));
        }
        else {
            friendChannelIds === null || friendChannelIds === void 0 ? void 0 : friendChannelIds.forEach((channelId) => {
                friendChannelButtons.push(_jsx(ChannelCard, { keyStr: "channelcard.friendchannels." + channelId, enableEditButtons: false, basePath: getContentURL(), channelJson: channelId, maxWidth: 0.22 }, "channelcard.friendchannels." + channelId));
            });
        }
    }
    let myChannelsContents = (_jsxs(Stack, Object.assign({ sx: {
            marginBottom: "10px",
            marginTop: "5px",
            marginLeft: "5px",
            marginRight: "5px",
        } }, { children: [_jsx(Divider, {}), _jsx(Typography, Object.assign({ variant: "h6", sx: { paddingLeft: "5px", paddingRight: "5px" } }, { children: "My Channels" })), _jsx(ContentCardStacks, { keyStr: "my.channel.buttons", cards: myChannelButtons, columnCount: 4 })] }), "mychannels.contents"));
    const friendChannelsContents = (_jsxs(Stack, Object.assign({ sx: {
            marginBottom: "10px",
            marginTop: "5px",
            marginLeft: "5px",
            marginRight: "5px",
        } }, { children: [_jsx(Divider, {}), _jsx(Typography, Object.assign({ variant: "h6", sx: { paddingLeft: "5px", paddingRight: "5px" } }, { children: "Friends Channels" })), _jsx(ContentCardStacks, { keyStr: "friend.channel.buttons", cards: friendChannelButtons, columnCount: 4 })] })));
    const earlyAddButton = (_jsx(Button, Object.assign({ variant: "contained", onClick: () => {
            logger.log(LOGPREFIX + "addMyChannelButton");
            setAddNewChannelFormVisible(true);
        }, sx: { margin: "8px" }, endIcon: _jsx(AddToQueueIcon, {}) }, { children: _jsx(Stack, Object.assign({ sx: { display: "flex", alignItems: "center" } }, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: "Create New Channel" })) })) }), "add.channel.button.early"));
    const discoveryChannelsContents = (_jsxs(Stack, Object.assign({ sx: {
            marginBottom: "10px",
            marginTop: "5px",
            marginLeft: "5px",
            marginRight: "5px",
        } }, { children: [_jsx(Divider, {}), _jsx(Typography, Object.assign({ variant: "h6", sx: { paddingLeft: "5px", paddingRight: "5px" } }, { children: "Trending Channels" })), _jsx(ContentCardStacks, { keyStr: "discovery.cards", cards: discoveryCards, columnCount: 4 })] })));
    const recentChannelsContents = (_jsxs(Stack, Object.assign({ sx: {
            marginBottom: "10px",
            marginTop: "5px",
            marginLeft: "5px",
            marginRight: "5px",
        } }, { children: [_jsx(Divider, {}), _jsx(Typography, Object.assign({ variant: "h6", sx: { paddingLeft: "5px", paddingRight: "5px" } }, { children: "Recent Channels" })), _jsx(ContentCardStacks, { keyStr: "recent.channel.buttons", cards: recentChannelButtons, columnCount: 4 })] })));
    const memberChannelsContents = (_jsxs(Stack, Object.assign({ sx: {
            marginBottom: "10px",
            marginTop: "5px",
            marginLeft: "5px",
            marginRight: "5px",
        } }, { children: [_jsx(Divider, {}), _jsx(Typography, Object.assign({ variant: "h6", sx: { paddingLeft: "5px", paddingRight: "5px" } }, { children: "Member Channels" })), _jsx(ContentCardStacks, { keyStr: "member.channel.buttons", cards: memberChannelButtons, columnCount: 4 })] })));
    if (myChannelsLoading) {
        myChannelsContents = _jsx(LinearProgress, {}, "mychannels.loading");
    }
    if (addNewChannelFormVisible && auth.userId) {
        myChannelsContents = (_jsx(NewChannelCard, { channelOwnerId: auth.userId, auth: auth, created: (newChannelName) => {
                window.location.href = getChannelViewBaseURL() + newChannelName;
            }, dismiss: () => {
                setAddNewChannelFormVisible(false);
            } }));
    }
    logger.log(LOGPREFIX +
        "Channels.render: memberChannelIds = " +
        JSON.stringify(memberChannelIds));
    const content = (_jsxs(Stack, Object.assign({ sx: { padding: 0, margin: 0 }, spacing: 0 }, { children: [_jsx(TopButtonMenu, { current: "channels" }), loading && (_jsx(LinearProgress, { sx: { width: "100%", margin: "2px" } }, "content.loading.spinner")), !loading && !addNewChannelFormVisible && earlyAddButton, !addNewChannelFormVisible &&
                recentChannelIds &&
                recentChannelIds.length > 0 &&
                recentChannelsContents, !addNewChannelFormVisible && discoveryChannelsContents, myChannelsContents, !addNewChannelFormVisible &&
                memberChannelIds &&
                memberChannelIds.length > 0 &&
                memberChannelsContents, !addNewChannelFormVisible &&
                friendChannelIds &&
                friendChannelIds.length > 0 &&
                friendChannelsContents] }), "content"));
    const output = (_jsx("div", Object.assign({ style: { width: "100%", padding: 0, margin: 0 }, id: "outer", "data-testid": "channels-page" }, { children: _jsxs(ThemeProvider, Object.assign({ theme: getTheme() }, { children: [_jsx(Heading, {}), _jsx(Container, Object.assign({ sx: {
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        margin: 0,
                        padding: 0,
                    }, maxWidth: false }, { children: content }), "channels.container"), _jsx(Footer, {})] })) }), "page.div.channels"));
    return output;
};
